import { getParamsUrl } from '@/helpers/request'
import Repository from './Repository'
const action = 'total-report'

export default {
  getList(settings) {
    return Repository.get(
      `${action}${getParamsUrl({ ...settings, enablePages: 1 })}`,
    )
  },
  get(id) {
    return Repository.get(`${action}?id=${id}`)
  },
  post(name, loadDyaIds) {
    const data = { name, fullReport: 0, load_day_ids: loadDyaIds }

    return Repository.post(`${action}`, data)
  },
  deleteResponse(reportId, responseId) {
    return Repository.get(
      `${action}/${reportId}/delete-response?response_id=${responseId}`,
    )
  },
  setApprovements(options) {
    return Repository.post('approvements', options)
  },
  getResponsesIdsWhichNotAdd(id) {
    return Repository.get(`${action}/${id}?expand=available-responses`)
  },
  addResponse(reportId, responseId) {
    return Repository.get(
      `${action}/${reportId}/add-response?response_id=${responseId}`,
    )
  },
  deleteReport(id) {
    return Repository.delete(`${action}/${id}`)
  },
  getRegistryPayments(reportId) {
    return Repository.get(
      `${action}/${reportId}/responses`,
    )
  },
  changeReportsStatuses(params) {
    return Repository.post(`${action}/set-status`, params)
  },
  deleteReports(params) {
    return Repository.post(`${action}/delete-report`, params)
  },
  addPayment(params) {
    return Repository.post(`${action}/add-payment`, params)
  },
  getReportComments(id) {
    return Repository.get(`${action}/get-comments?total_report_id=${id}`)
  },
  addReportComment(params) {
    return Repository.post(`${action}/add-comment`, params)
  },
}
